<template>
    <div class="page-block__item-wrapper">
        <administrative-status
            :label="trans('subscriptions.administrative_status')"
            :status="subscription.administrative_status"
        />

        <renewal-date :label="trans('hosting.renew-date')" :renewDate="subscription.end_date" :subscription="subscription" />

        <start-date :label="trans('hosting.start-date')" :startDate="subscription.start_date" />

        <subscription-period
            :label="trans('hosting.period')"
            :period="subscription.period"
            :periodSuffix="trans('hosting.period-suffix')"
            :renewable="true"
            :renewLabel="trans('hosting.period-button')"
        />

        <subscription-type
            :label="trans('hosting.type')"
            :type="subscription.product_name"
            :modifiable="true"
            :modifyLabel="trans('hosting.type-button')"
        />
    </div>
</template>

<script>
import { AdministrativeStatus, RenewalDate, SubscriptionPeriod, SubscriptionType } from 'relapp-technical-management';

export default {
    components: {
        AdministrativeStatus,
        RenewalDate,
        SubscriptionPeriod,
        SubscriptionType
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    }
};
</script>
